module.exports = __webpack_public_path__ + "img/loader1.8d98bd8e.svg";